import { observer } from 'mobx-react';
import React from 'react';

import { getAppBroker } from 'stores/AppBroker';
import type BreadcrumbManager from 'stores/BreadcrumbManager';

import {
  Breadcrumb,
  BreadcrumbContainer,
  Container,
} from './NavBreadcrumb.styles';

export interface NavBreadcrumbProps {
  breadcrumbs: BreadcrumbManager;
  className?: string;
}

function NavBreadcrumb(props: NavBreadcrumbProps) {
  const { breadcrumbs } = props;
  if (!breadcrumbs) return null;

  const userIsAuthenticated = Boolean(
    getAppBroker().getCurrentUser()?.authenticated
  );

  const items = breadcrumbs.all.map((breadcrumb, index) => {
    const essentials = { key: index, title: breadcrumb.name };
    return userIsAuthenticated && breadcrumb.url
      ? {
          ...essentials,
          href: breadcrumb.url,
          onClick: (e: React.MouseEvent) => {
            e.preventDefault();
            breadcrumb.navigateTo();
          },
        }
      : essentials;
  });

  return (
    <Container className={props.className}>
      <BreadcrumbContainer>
        <Breadcrumb items={items} />
      </BreadcrumbContainer>
    </Container>
  );
}

export default observer(NavBreadcrumb);
